import { Box } from "@mui/material";
import { styled } from "@mui/material";
import { Poppins } from "next/font/google";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

export const DrawerHeaderContainer = styled(Box)(({ theme }) => ({
  padding: "20px 24px",
  borderBottom: "1px solid #E8EAED",
  fontFamily: poppins.style.fontFamily,
  display: "flex",
  alignContent: "center",
  position: "relative",
  "& .MuiTypography-root": {
    flex: 1,
    color: "#001233",
    fontFamily: poppins.style.fontFamily,
    fontWeight: 600,
    textAlign: "center",
  },
  "& .StartButton": {
    position: "absolute",
    left: "12px",
    bottom: "10px",
    color: "#0B132B",
  },
  "& .StartButton svg": {
    color: "#0B132B",
  },
  "& .EndButton": {
    position: "absolute",
    right: "12px",
    bottom: "10px",
    color: "#0B132B",
  },
  "& .EndButton svg": {
    color: "#0B132B",
  },
}));
